import { render, staticRenderFns } from "./BankSlipTemplate.vue?vue&type=template&id=51a5ac84&"
import script from "./BankSlipTemplate.vue?vue&type=script&lang=js&"
export * from "./BankSlipTemplate.vue?vue&type=script&lang=js&"
import style0 from "./BankSlipTemplate.vue?vue&type=style&index=0&id=51a5ac84&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports